import { render, staticRenderFns } from "./BillingView.vue?vue&type=template&id=2ae1c875&scoped=true&"
import script from "./BillingView.vue?vue&type=script&lang=js&"
export * from "./BillingView.vue?vue&type=script&lang=js&"
import style0 from "./BillingView.vue?vue&type=style&index=0&id=2ae1c875&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae1c875",
  null
  
)

export default component.exports